import { useState } from "react"
import { useFocusManagement } from "components/TreeState"
import { isEqual } from "lodash"

type Value =
  | string
  | Date
  | Record<string, any>
  | Record<string, any>[]
  | undefined
  | null

export function useAutocomputeValidation(initValue?: Value, isInput?: boolean) {
  const { getInputProps } = useFocusManagement() ?? {}
  const { onFocus } = getInputProps()
  const [initialValue, setInitialValue] = useState<Value>()

  const handleFocus = () => {
    isInput && onFocus()
    setInitialValue(initValue)
  }

  const hasChanged = (value: Value) => !isEqual(value, initialValue)

  return { handleFocus, hasChanged }
}
